import { Injectable } from '@angular/core';
import { Lookup } from '@common/utilities/Lookup';
import { DataService, TagRecord } from './data.service';
import { SynchronizationService } from './synchronization.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class TagsService {

  private lookupById = new Lookup<TagRecord>(i => i.InvoiceID);
  private lookupByTag = new Lookup<TagRecord>(i => i.Tag);  

  private _sync(notify = true) {

    if (notify) this.sync.notify(TagsService, false);

    this.ds.tags('list').subscribe(tags => {

      if (tags) {
        this.lookupById.source = tags;
        this.lookupByTag.source = tags;

        this.sync.notify(TagsService, true);
      }
      else {
        if (this.api.authorized) {
          this._sync(false);
        }
        else {
          this.api.credentialChanged.subscribe(user => {
            this._sync(false);
          });
        }
      }
    });
  }

  public synchronize() {
    this._sync();
  }

  private clone(tag: TagRecord): TagRecord {
    return tag ? { ...tag } : null;
  }

  public get(tag: string | number): TagRecord {

    switch (typeof tag) {
      case 'string': return this.clone(this.lookupByTag.get(tag, null));
      case 'number': return this.clone(this.lookupById.get(tag, null));
      default: return null;
    }    
  }

  public get all(): TagRecord[] {
    return this.lookupById.source.map(i => this.clone(i));
  }

  constructor(private ds: DataService, private api: ApiService, private sync: SynchronizationService) {
    this._sync();
  }
}
